'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitDrawerBase } from '@/fo/ui/kit/drawer/base';

import { ContactForm } from '../ContactForm/ContactForm';

import { styles } from './Modal.styles';

export interface ModalProps {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function Modal({ open = false, onOpenChange = () => {} }: ModalProps) {
  const slots = styles();
  const t = useTranslations();
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);

  const onChange = (open: boolean) => {
    onOpenChange(open);
  };

  return (
    <div className={slots.base()}>
      <UiKitDrawerBase
        open={open}
        direction="right"
        onOpenChange={onChange}
        title={t('contactInfo.question')}
        contentClassName={slots.drawer()}
      >
        {showSuccessMsg && (
          <div className={slots.success()}>
            <p className={slots.title()}>{t('Data sent')}!</p>
            <p className={slots.description()}>{t('contactInfo.answer')}</p>
            <UiKitButtonBase
              type="submit"
              color="secondary"
              className={slots.button()}
              onClick={() => onChange(false)}
            >
              {t('Good')}
            </UiKitButtonBase>
          </div>
        )}

        {!showSuccessMsg && (
          <>
            <p className={slots.title()}>{t('contactInfo.question')}</p>
            <p className={slots.description()}>{t('contactInfo.answer')}</p>
            <ContactForm onReset={() => setShowSuccessMsg(true)} />
          </>
        )}
      </UiKitDrawerBase>
    </div>
  );
}
